import React, { Component } from 'react';
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell
} from "@mui/material";
import TextField from '@mui/material/TextField';
import Button from "react-bootstrap/Button";
import SystemSettingsActionButton from "../../../components/settings/SystemSettingsActionButton.js";
import Modal from "react-bootstrap/Modal";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import InputAdornment from '@mui/material/InputAdornment';
import SimpleReactValidator from "simple-react-validator";
import { roleService } from '../../../service/user_management/role.service.js';
import { Spinner } from 'react-bootstrap';
import { sweetErrorAlert, sweetStatusAlert, sweetSuccessAlert } from '../../../components/common/SweetAlert.js';
import ContentWrapper from '../../../components/common/ContentWrapper.js';
import config from '../../../helper/config.js';
import {customerConstants, userTypes} from "../../../helper/constants.js";
import MaterialCustomTablePagination from "../../../components/common/MaterialCustomTablePagination.js";
import debounce from "lodash.debounce";
import PageSpinner from "../../../components/common/spinner/PageSpinner.js";
import sweetAlert, {sweetConfirmAlert} from "../../../components/common/SweetAlert.js";
import { userTypeService } from '../../../service/user_management/user_type.service.js';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle
const customer = getCustomerFeatureFlag()
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    break
  case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
      color: "var(--maincolor-cmc)",
      backgroundColor: "#E5F5FF",
      borderColor: "transparent"
    }
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor-cmc)",
      borderColor: "transparent"
    }
    break
  default:
    break
}

class ManageRoles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      role_name: "",
      role_desc: "",
      role_code: "",
      role_user_type_id: null,
      user_type_id: null,
      roles: [],
      userTypes: [],
      limit: 10, 
      offset: 0, 
      search_term: "",
      sort_column: "role_name",
      sort_direction: "ASC",
      totalRoles: 10,
      currentPage: 0,
      editVisibility: true,
      addVisibility: true,
      deleteVisibility: true,
    };
    this.validator = new SimpleReactValidator();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEditSubmit = this.handleEditSubmit.bind(this);
    // Debounced version of handleSearch function
    this.debouncedHandleSearch = debounce(this.fetchAllRolesData, 2000);
  }

  resetFormFields = () => {
      this.setState({
        role_name: "",
        role_desc: "",
        role_code: "",
        role_user_type_id: null,
    });
  };

  componentDidMount() {
    this.fetchAllRolesData();
    this.getAllUserTypes();
  }

  fetchAllRolesData() {
      const { limit, offset, search_term, sort_column, sort_direction } = this.state;
      roleService.getAllRoles(limit, offset, search_term, sort_column, sort_direction)
      .then((response) => {
          if (response.success) {
          this.setState({
              roles: response.data.roles,
              totalRoles: parseInt(response.data.total_count),
          });
          } else {
          sweetStatusAlert(
              "Failed!",
              "Error fetching Roles. Please refresh the screen!",
              "error"
          );
          }
      })
      .catch((error) => {
          sweetStatusAlert(
          "Failed!",
          "Error fetching Roles. Please refresh the screen!",
          "error"
          );
      })
      .finally(() => {
          this.setState({ isLoading: false, isSpinnerLoading: false });
      });
  }

  getAllUserTypes = async() => {
    this.setState({ isLoading: true });
    await userTypeService.getAllUserTypes()
    .then((response) => {
        if (response.success) {
        this.setState({
          userTypes: response.data.user_types
        });
        } else {
        sweetStatusAlert(
            "Failed!",
            "Error fetching User Types. Please refresh the screen!",
            "error"
        );
        }
    })
    .catch((error) => {
        sweetStatusAlert(
        "Failed!",
        "Error fetching User Types. Please refresh the screen!",
        "error"
        );
    })
    .finally(() => {
      this.setState({ isLoading: false });
    });
  }

  handlePageChange = (event, newPage) => {
    const { limit } = this.state;
    const newOffset = newPage * limit;
    this.setState(
    {
        offset: newOffset,
        isLoading: true,
        currentPage: newPage,
    },
    () => {
        this.fetchAllRolesData();
    }
    );
};

handleSortChange = (sort_column) => {
    // If the same column is clicked, toggle the sort direction
    const { sort_column: currentSortColumn, sort_direction } = this.state;
    const newSortDirection =
        currentSortColumn === sort_column && sort_direction === "ASC"
        ? "DESC"
        : "ASC";

    this.setState(
        {
        sort_column,
        sort_direction: newSortDirection,
        offset: 0, // Reset offset when changing sorting
        currentPage: 0,
        isLoading: true,
        },
        () => {
        this.fetchAllRolesData();
        }
    );
};

handlePageOffsetChange = (newOffset, newPage) => {
    this.setState(
    {
        offset: newOffset,
        isLoading: true,
        currentPage: newPage
    },
    () => {
        this.fetchAllRolesData();
    }
    );
};

handleRowsPerPageChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    const newPage = Math.floor(this.state.offset / newLimit);
    this.setState(
    {
        limit: newLimit,
        offset: newLimit * newPage,
        isLoading: true,
        currentPage: newPage,
    },
    () => {
        this.fetchAllRolesData();
    }
    );
};

handleSearch = (event) => {
    const search_term = event.target.value.trim();
    const regex = /^[a-zA-Z0-9][a-zA-Z0-9@\s.&]*$/;

    if (search_term === "" || regex.test(search_term)) {
    this.setState(
        {
        search_term,
        isLoading: true,
        offset: 0,
        currentPage: 0,
        searchError: false,
        },
        () => {
        this.debouncedHandleSearch();
        }
    );
    } else {
    this.setState({ search_term, searchError: true });
    }
};

toggleRoleModal = (modalType) => {
    this.modalType = modalType;
    this.setState((prevState) => ({
     showModal: !prevState.showModal,
    }));
};

toggleUpdateRoleModal = (role_name, role_code, role_desc, role_user_type_id, modalType) => {
    this.setState((prevState) => ({
        showModal: !prevState.showModal,
        role_name: role_name,
        role_code: role_code,
        role_desc: role_desc,
        role_user_type_id: role_user_type_id,
        modalType: modalType,
    }));
};

handleChange = (event) => {
    const { name, value } = event.target;
    this.setState(() => ({ [name]: value, isModified: true }));
};

handleChangeRoleUserType = (event) => {
  event.preventDefault();
  this.setState({ role_user_type_id: event.target.value });
};

handleSweetAlert = (modalType, modalVisibility) => {
    if (this.state.isModified) {
        sweetAlert().then((response) => {
            this.validator.hideMessages();
            this.validator.purgeFields();
            this.resetFormFields();
            this.modalType = false;
            this.setState(() => ({
            [modalVisibility]: response,
            isModified: false,
            }));
        });
    } else {
        this.validator.hideMessages();
        this.validator.purgeFields();
        this.resetFormFields();
        if (modalType) this.toggleRoleModal(false);
        else this.toggleUpdateRoleModal();
    }
};

//Handle Edit Submit
handleEditSubmit = (event) => {
    event.preventDefault();

    if (!this.validator.allValid()) {
        this.validator.showMessages();
        this.forceUpdate();
    } 
    else 
    {
        this.setState({ isSpinnerLoading: true });
        const roleItem = {
          role_name: this.state.role_name,
          role_code: this.state.role_code,
          role_desc: this.state.role_desc,
          role_user_type_id: parseInt(this.state.role_user_type_id)
        };
        const roleCode = this.state.role_code;

        roleService.updateUserRole(roleItem, roleCode)
            .then((response) => {
            if (response.success) {
                this.setState({ isSpinnerLoading: false });
                this.toggleRoleModal();
                sweetStatusAlert(
                "Success!",
                "Role information updated successfully!",
                "success"
                );
                this.validator.hideMessages();
                this.validator.purgeFields();
                this.resetFormFields();
                this.fetchAllRolesData();
            }else {
                this.setState({ isSpinnerLoading: false });
                sweetStatusAlert("Failed!", response.message, "error");
            }
            })
            .catch((error) => {
            this.setState({ isSpinnerLoading: false });
            sweetStatusAlert(
                "Failed!",
                "Unable to update the Role information",
                "error"
            );
            });
    }
};

//add new Role
handleSubmit = (event) => {
    event.preventDefault();

    if (!this.validator.allValid()) {
        this.validator.showMessages();
        this.forceUpdate();
    } 
    else 
    {
        this.setState({ isSpinnerLoading: true });
        const newRole = {
          role_name: this.state.role_name,
          role_code: this.state.role_code,
          role_desc: this.state.role_desc,
          role_user_type_id: parseInt(this.state.role_user_type_id)
        };

        roleService.addUserRole(newRole)
            .then((response) => {
            if (response.success) {
                sweetStatusAlert("Success!", response.message.success, "success");
                this.validator.hideMessages();
                this.validator.purgeFields();
                this.resetFormFields();
                this.toggleRoleModal(false);
                this.fetchAllRolesData();
            } else {
                this.setState({ isSpinnerLoading: false });
                sweetStatusAlert("Failed!", response.message, "error");
            }
            })
            .catch((err) => {
                this.setState({ isSpinnerLoading: false });
                sweetStatusAlert("Failed!", "Unable to create new Role", "error");
            });
    }
};

handleDeleteRole = (role_code) => {
    sweetConfirmAlert().then(() => {
    this.setState({ isSpinnerLoading: true });
    roleService.deleteUserRole(role_code)
        .then((response) => {
        if (response.success) {
            sweetStatusAlert("Success!", response.message.success, "success");
            this.fetchAllRolesData();
            this.setState({ isSpinnerLoading: false });
        } else {
            sweetStatusAlert("Failed!", response.message, "error");
            this.setState({ isSpinnerLoading: false });
        }
        })
        .catch((error) => {
            sweetStatusAlert("Oops!", "Error while deleting the Role", "info");
            this.setState({ isSpinnerLoading: false });
        });
    });
};

render() {
    const {
        limit,
        roles,
        totalRoles,
        isLoading,
        currentPage,
        isSpinnerLoading,
        editVisibility,
        addVisibility,
        deleteVisibility,
    } = this.state;
    return (
    <>
        <ContentWrapper>
        <div className="row justify-content-between align-items-center py-5 mb-3">
            <div className="col-md-6 col-6">
            <h3 className="text-nowrap">Manage Roles</h3>
            </div>
            <div>
            {addVisibility && (
                <Button
                  className="insert-btn"
                  variant="primary"
                  onClick={() => this.toggleRoleModal(true)}
                >
                  Add Role
                </Button>
            )}
            </div>
        </div>
        <div>
            <Form.Group controlId="exampleForm.ControlInput1" className="mb-2">
            <Form.Control
                type="text"
                placeholder="Search"
                onChange={this.handleSearch}
                isInvalid={this.state.searchError}
                // style={{ width: "18%" }}
                className="col-md-3 col-12"
            />
            {this.state.searchError && (
                <Form.Control.Feedback type="invalid">
                    Invalid input
                </Form.Control.Feedback>
            )}
            </Form.Group>
            {isSpinnerLoading && (
            <PageSpinner id="show" text="Loading, Please wait!" />
            )}
            {isLoading ? (
            <div
                className="loading-container"
                style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "75vw",
                height: "90vh",
                }}
            >
                <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
                </Spinner>
            </div>
            ) : roles.length > 0 ? (
            <div style={{ width: "100%", height: "90vh", overflow: "auto" }}>
                <Table>
                <TableHead>
                    <TableRow>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("role_code")}
                    >
                        Role Code{" "}
                        {this.state.sort_column === "role_code" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("role_name")}
                    >
                        Role Name{" "}
                        {this.state.sort_column === "role_name" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("role_desc")}
                    >
                        Role Description{" "}
                        {this.state.sort_column === "role_desc" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("role_user_type_id")}
                    >
                        Role User Type{" "}
                        {this.state.sort_column === "role_user_type_id" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    {(editVisibility || deleteVisibility) && (
                        <TableCell className="thead">Actions</TableCell>
                    )}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {roles.map((roleItem) => (
                    <TableRow key={roleItem.role_code}>
                        <TableCell className="tData">
                          {roleItem.role_code}
                        </TableCell>
                        <TableCell className="tData">
                          {roleItem.role_name}
                        </TableCell>
                        <TableCell className="tData">
                          {roleItem.role_desc}
                        </TableCell>
                        <TableCell className="tData">
                          {roleItem.user_type}
                        </TableCell>
                        {(editVisibility || deleteVisibility) && (
                        <TableCell>
                            <div className="system-settings-action-group">
                            {editVisibility && (
                                <SystemSettingsActionButton type="edit"
                                    onClick={() =>
                                        this.toggleUpdateRoleModal(
                                            roleItem.role_name,
                                            roleItem.role_code,
                                            roleItem.role_desc,
                                            roleItem.role_user_type_id,
                                            false
                                        )
                                    }
                                    title="Edit Details"
                                 />
                            )}
                            {deleteVisibility && (
                                <SystemSettingsActionButton type="delete"
                                    onClick={() =>
                                        this.handleDeleteRole(
                                            roleItem.role_code
                                        )
                                    }
                                    title="Delete"
                                 />
                            )}
                            </div>
                        </TableCell>
                        )}
                    </TableRow>
                    ))}
                </TableBody>
                </Table>
                <MaterialCustomTablePagination
                    totalCount = {totalRoles}
                    currentPage = {currentPage}
                    limit = {limit}
                    handlePageChange = {this.handlePageChange}
                    handleRowsPerPageChange = {this.handleRowsPerPageChange}
                    handlePageOffsetChange = {this.handlePageOffsetChange}
                    offset = {this.state.offset}
                    rowsPerPageOptions={[5, 10, 20]}
                />
            </div>
            ) : (
            <div
                className="text-center mb-5 mt-10"
                style={{ height: "90vh" }}
            >
                <label>No Roles Available!</label>
            </div>
            )}
        </div>
        </ContentWrapper>

        {/* user_type add and update model */}
        <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={this.state.showModal}
        onHide={() => this.handleSweetAlert(this.modalType, "showModal")}
        >
        {this.modalType === true ? (
            <div>
            <Modal.Header closeButton>
                <Modal.Title>Add Role</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                <Row className="my-5">
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Role Name*</Form.Label>
                    <Form.Control
                        type="text"
                        name="role_name"
                        placeholder="Type role name here..."
                        value={this.state.role_name}
                        onChange={this.handleChange}
                    />
                    {this.validator.message(
                        "role_name",
                        this.state.role_name,
                        "required|alpha_space|max:30",
                        {
                        className: "text-danger",
                        messages: {
                            max: "role name should not be greater than 30 characters.",
                            alpha_space:
                            "role name must have valid characters.",
                            required: "role name field is required.",
                        },
                        }
                    )}
                    </Form.Group>
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Role Code*</Form.Label>
                    <Form.Control
                        type="text"
                        name="role_code"
                        placeholder="Type role code here..."
                        value={this.state.role_code}
                        onChange={this.handleChange}
                    />
                    {this.validator.message(
                        "role_code",
                        this.state.role_code,
                        "required|alpha_space|max:5",
                        {
                        className: "text-danger",
                        messages: {
                            max: "role code should not be greater than 5 characters.",
                            alpha_space:
                            "role code must have valid characters.",
                            required: "role code field is required.",
                        },
                        }
                    )}
                    </Form.Group>
                </Row>
                <Row className="my-5">
                  <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput1"
                  >
                  <Form.Label>Role Description*</Form.Label>
                  <Form.Control
                      as="textarea"
                      rows={2} 
                      type="text"
                      name="role_desc"
                      placeholder="Type role description here..."
                      value={this.state.role_desc}
                      onChange={this.handleChange}
                  />
                  {this.validator.message(
                      "role_desc",
                      this.state.role_desc,
                      "required|alpha_space|max:100",
                      {
                      className: "text-danger",
                      messages: {
                          max: "role description should not be greater than 100 characters.",
                          alpha_space:
                          "role description must have valid characters.",
                          required: "role description field is required.",
                      },
                      }
                  )}
                  </Form.Group>
                  <Form.Group
                    as={Col}
                    md="6"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Select User Type*</Form.Label>
                    <Form.Select
                          id="role_user_type"
                          value={this.state.role_user_type_id || ""}
                          onChange={this.handleChangeRoleUserType}
                          className="form-control"
                        >
                          <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                          {this.state.userTypes.map((option, index) => (
                            <option key={index} value={option.user_type_id}>
                              {option.user_type}
                            </option>
                          ))}
                    </Form.Select>
                    {this.validator.message(
                      "role_user_type",
                       this.state.role_user_type_id,
                      "required",
                      {
                        className: "text-danger",
                      }
                    )}
                  </Form.Group>
                </Row>
                </Form>
            </Modal.Body>

            <Modal.Footer>
                <Button
                variant="primary"
                style={addBtnStyle}
                onClick={this.handleSubmit}
                >
                  Save changes
                </Button>
                <Button
                id="modal-close-button"
                style={closeBtnStyle}
                onClick={() =>
                    this.handleSweetAlert(this.modalType, "showModal")
                }
                >
                  Close
                </Button>
            </Modal.Footer>
            </div>
        ) : (
            <div>
            <Modal.Header closeButton>
                <Modal.Title>Update Role</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                <Row className="my-5">
                  <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput1"
                  >
                  <Form.Label>Role Name*</Form.Label>
                  <Form.Control
                      type="text"
                      name="role_name"
                      placeholder="Type role name here..."
                      value={this.state.role_name ? this.state.role_name : ""}
                      onChange={this.handleChange}
                  />
                  {this.validator.message(
                      "role_name",
                      this.state.role_name,
                      "required|alpha_space|max:30",
                      {
                      className: "text-danger",
                      messages: {
                          max: "role name should not be greater than 30 characters.",
                          alpha_space:
                          "role name must have valid characters.",
                          required: "role name field is required.",
                      },
                      }
                  )}
                  </Form.Group>
                  {/* <Form.Group
                      as={Col}
                      md="6"
                      controlId="exampleForm.ControlInput1"
                  >
                  <Form.Label>Role Code*</Form.Label>
                  <Form.Control
                      type="text"
                      name="role_code"
                      placeholder="Role Code"
                      value={this.state.role_code ? this.state.role_code : ""}
                      onChange={this.handleChange}
                  />
                  {this.validator.message(
                      "role_code",
                      this.state.role_code,
                      "required|alpha_space|max:5",
                      {
                      className: "text-danger",
                      messages: {
                          max: "role code should not be greater than 5 characters.",
                          alpha_space:
                          "role code must have valid characters.",
                          required: "role code field is required.",
                      },
                      }
                  )}
                  </Form.Group> */}
                  <Form.Group
                    as={Col}
                    md="6"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Select User Type*</Form.Label>
                    <Form.Select
                          id="role_user_type"
                          value={this.state.role_user_type_id || ""}
                          onChange={this.handleChangeRoleUserType}
                          className="form-control"
                        >
                          <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                          {this.state.userTypes.map((option, index) => (
                            <option key={index} value={option.user_type_id}>
                              {option.user_type}
                            </option>
                          ))}
                    </Form.Select>
                    {this.validator.message(
                      "role_user_type",
                       this.state.role_user_type_id,
                      "required",
                      {
                        className: "text-danger",
                      }
                    )}
                  </Form.Group>
                </Row>
                <Row className="my-5">
                  <Form.Group
                      as={Col}
                      md="10"
                      controlId="exampleForm.ControlInput1"
                  >
                  <Form.Label>Role Description*</Form.Label>
                  <Form.Control
                      as="textarea"
                      rows={2} 
                      type="text"
                      name="role_desc"
                      placeholder="Type role description here..."
                      value={this.state.role_desc ? this.state.role_desc : ""}
                      onChange={this.handleChange}
                  />
                  {this.validator.message(
                      "role_desc",
                      this.state.role_desc,
                      "required|alpha_space|max:100",
                      {
                      className: "text-danger",
                      messages: {
                          max: "role description should not be greater than 100 characters.",
                          alpha_space:
                          "role description must have valid characters.",
                          required: "role description field is required.",
                      },
                      }
                  )}
                  </Form.Group>
                </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button
                className="modal-btn"
                variant="primary"
                style={addBtnStyle}
                onClick={this.handleEditSubmit}
                >
                    Save changes
                </Button>
                <Button
                className="modal-btn"
                id="modal-close-button"
                style={closeBtnStyle}
                onClick={() =>
                    this.handleSweetAlert(this.modalType, "showModal")
                }
                >
                    Close
                </Button>
            </Modal.Footer>
            </div>
        )}
        </Modal>
    </>
    );
}
}

export default ManageRoles;

